import AlertModel from '@/common/models/alert.model';
import mutations from '@/common/store/modules/common/common.mutations';

enum AlertOperation {
  Deleted = 'deleted'
}

const alertsGetters: CommonGetterTree<any> = {
  counters: (_state, getters) => getters.getItems.reduce((acc, alert) => {
    acc[alert.severity] = acc[alert.severity] !== undefined ? acc[alert.severity] + 1 : 1;
    return acc;
  }, {})
};

const alertsMutations: CommonMutationTree<any> = {
  CHANGE(state, { item }): void {
    const needRemove = !item.enabled || new Date(item.suspended).getTime() > Date.now();
    const newItem = {
      ...item,
      id: item.id.toString()
    };
    if (needRemove) {
      this.commit('alerts/REMOVE', newItem.id);
      return;
    }
    mutations().CHANGE(state, { item: newItem });
  }
};

const alertsActions: CommonActionTree<any> = {
  socket_alerts({ dispatch }, { object, operation }: SocketPayload<never>): void {
    if (object?.id) {
      const id = object.id.toString();
      if (operation === AlertOperation.Deleted) {
        dispatch('ABORT_AND_REMOVE', { actionName: 'alerts/FETCH_ITEM', payload: { id } });
      } else {
        this.$takeLast('alerts/FETCH_ITEM', { id });
      }
    }
  },
};

export default new class implements CommonStore<any, AlertModel> {
  name = 'alerts';
  resource = '/api/v2/alerts';
  config = {
    updateMethod: 'put',
  };

  Model = AlertModel;
  getters = alertsGetters;
  mutations = alertsMutations;
  actions = alertsActions;
}();
